module.exports = __webpack_public_path__ + "static/media/hexagon-landing-page-portfolio.c4528801.jpg";